<template>
    <div style="height: 600px;">
        <el-form ref="goodsRecoForm" label-width="80px" style="margin-right: 10prx;">
            <el-form-item label="录入项" style="margin-bottom: 0;">
                <div>忽略前缀,或识别录入(多个逗号分隔)</div>
            </el-form-item>      
            <el-form-item label="英文名称" style="margin-bottom: 0;">
                <el-input v-model="setting.goodNameEnglish" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('goodNameEnglish')"></el-input>
            </el-form-item>
            <el-form-item label="中文名称" style="margin-bottom: 0;">
                <el-input v-model="setting.goodNameChinese" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('goodNameChinese')"></el-input>
            </el-form-item>                                  
            <el-form-item label="材质" style="margin-bottom: 0;">
                <el-input v-model="setting.materialEnglish" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('materialEnglish')"></el-input>
            </el-form-item>              
            <el-form-item label="用途" style="margin-bottom: 0;">
                <el-input v-model="setting.purposeEnglish" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('purposeEnglish')"></el-input>
            </el-form-item> 
            <el-form-item label="商品编码" style="margin-bottom: 0;">
                <el-input v-model="setting.hsGoodCode" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('hsGoodCode')"></el-input>
            </el-form-item>              
            <el-form-item label="中文材质" style="margin-bottom: 0;">
                <el-input v-model="setting.materialChinese" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('materialChinese')"></el-input>
            </el-form-item>
            <el-form-item label="中文用途" style="margin-bottom: 0;">
                <el-input v-model="setting.purposeChinese" type="textarea" :autosize="{ minRows: 1, maxRows: 6}" maxlength="500" @input="changed=true"
                    @blur="splitField('purposeChinese')"></el-input>
            </el-form-item>                                               
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        setting: {
            type: Object
        }
    },
    mounted(){
        if(this.setting){
            this.splitField('goodNameEnglish')
            this.splitField('goodNameChinese')
            this.splitField('materialEnglish')
            this.splitField('purposeEnglish')
            this.splitField('hsGoodCode')
            this.splitField('materialChinese')
            this.splitField('purposeChinese')
        }
    },
    data(){
        return{
            changed: false
        }
    },
    methods:{
        isChanged(){
            return this.changed;
        },
        setChanged(value){
            this.changed = value
        },
        splitField(fieldName){
            let value = this.setting[fieldName]
            if(value){
                let arr = value.replace('：', ':').split(/,|，|\n/)
                arr = arr.filter((item)=>item);                
                this.setting[fieldName] = arr.join('\n')
            }
        }
    },
}
</script>

<style>
</style>
